import {
  CLOUDS_3D_ILLUSTRATION,
  INSIGHTS_ROCKET,
} from "../../constants/imageConstants";
import Star from "../common/Star";
import { useInsightsData } from "../../hooks/useInsightsData";

export default function InsightsHero() {
  const { data } = useInsightsData();

  return (
    <>
    <div className="relative px-5 sm:px-10 md:px-16 py-10 min-h-[50vh] flex">
      <Star />
      <div className="grid md:grid-cols-2 gap-8 lg:gap-16 justify-center">
        {/* Left Content */}
        <div className="space-y-6 lg:space-y-14 z-10">
          <h1 className="text-4xl md:text-6xl xl:text-9xl font-bold leading-tight text-white tracking-wide wifull">
            <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent drop-shadow-[0px_4px_10px_rgba(255,255,255,0.25)]">
              {data.heroSection.title}
            </span>
          </h1>

          {/* Mobile/Tablet 3D Graphics (Middle) */}
          <div className="relative flex justify-center items-center md:hidden min-h-[50vh]">
            {/* Background Clouds */}
            <div className="absolute inset-0 -top-64 -left-60 flex justify-center items-center">
              <img
                src={CLOUDS_3D_ILLUSTRATION}
                alt="3D Clouds"
                className="w-80 z-10 lg:w-[400px] xl:w-[469px] h-auto animate-float animate-delay-0"
              />
            </div>

            {/* Paper Plane */}
            <div className="relative z-20 flex justify-center items-center">
              <img
                src={INSIGHTS_ROCKET}
                alt="Rocket"
                className="w-80 lg:w-[380px] xl:w-[438px] h-auto animate-float animate-delay-2"
              />
            </div>

            {/* Bottom Clouds */}
            <div className="absolute bottom-0 right-0 transform rotate-180 scale-y-[-1]">
              <img
                src={CLOUDS_3D_ILLUSTRATION}
                alt="3D Clouds Bottom"
                className="w-64 lg:w-80 z-10 xl:w-[350px] h-auto opacity-90 animate-float animate-delay-0"
              />
            </div>
          </div>

          <p className="text-lg lg:text-xl text-[#d9d9d9] leading-relaxed max-w-2xl px-4 border-l-2">
            {data.heroSection.description}
          </p>
        </div>

        {/* Right Content - 3D Graphics */}
        <div className="relative hidden md:flex justify-center items-center order-first md:order-last">
          {/* Background Clouds */}
          <div className="absolute inset-0 -top-96 -left-60 flex justify-center items-center">
            <img
              src={CLOUDS_3D_ILLUSTRATION}
              alt="3D Clouds"
              className="w-80 z-10 lg:w-[400px] xl:w-[469px] h-auto animate-float animate-delay-0"
            />
          </div>

          {/* Paper Plane */}
          <div className="relative z-20 top-10 -left-10 flex justify-center items-center">
            <img
              src={INSIGHTS_ROCKET}
              alt="Rocket"
              className="w-[400px] xl:w-[600px] h-auto animate-float animate-delay-2"
            />
          </div>

          {/* Bottom Clouds */}
          <div className="absolute z-10 bottom-10 right-0 transform rotate-180 scale-y-[-1]">
            <img
              src={CLOUDS_3D_ILLUSTRATION}
              alt="3D Clouds Bottom"
              className="w-64 lg:w-80 xl:w-[350px] h-auto opacity-90 animate-float animate-delay-0"
            />
          </div>
        </div>
      </div>
    </div>
    <h2 className="text-white text-center text-4xl md:text-6xl font-medium mb-2 tracking-wider uppercase py-8 md:py-16 bg-[#D9D9D9]/10">
        {data.heroSection.sectionTitle}
      </h2>
    </>
  );
}
